import { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { getNews } from "../../../store/actions/adminActions/newsAction";
import { getDataAPI } from "../../../services/apiWrapper";

export function useLoadMore(url, pageNumber) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  // The url the rows currently held were loaded from. Callers that filter -
  // the gallery filtering by album - change the url, and that is a different
  // list, not more of the same one.
  const [loadedFrom, setLoadedFrom] = useState(url);
  const dispatch = useDispatch();

  useEffect(async () => {
    setLoading(true);
    setError(false);

    const isNewList = url !== loadedFrom;
    if (isNewList) {
      setLoadedFrom(url);
    }

    try {
      const response = await dispatch(getDataAPI(`${url}${pageNumber}`));
      // if (response) {
      setHasMore(true);
      setLoading(false);
      setData((prevData) => {
        const incoming = response.data.data?.data || [];
        return isNewList ? incoming : [...prevData, ...incoming];
      });
      //   });
      // } else {
      // }

      // return {
      //   data: response.data.data?.data || [],
      //   last_page: response.data.data.last_page,
      // };
    } catch (error) {
      // const response = await dispatch(getNews(pageNumber));

      // dispatch({ type: ALERT, payload: { error: error.response.data.message } });
      setLoading(false);
      setHasMore(false);
    }
  }, [pageNumber, url]);
  return [loading, data, setData, hasMore];
}
